import React from 'react'

const ArrowDown = props => (
    <svg {...props} width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.9" fillRule="evenodd" clipRule="evenodd" d="M0.283746 0.776393C0.368442 0.607001 0.541574 0.5 0.73096 0.5H3.73096C3.92035 0.5 4.09348 0.607001 4.17817 0.776393C4.26287 0.945785 4.24459 1.14849 4.13096 1.3L2.63096 3.3C2.53653 3.4259 2.38834 3.5 2.23096 3.5C2.07358 3.5 1.92539 3.4259 1.83096 3.3L0.33096 1.3C0.217328 1.14849 0.19905 0.945785 0.283746 0.776393Z" fill="white"/>
    </svg>
)

export default ArrowDown